export default __webpack_public_path__ + "static/media/sidebar-icon-messages.6c131651.svg";